import { useMemo } from "react";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { ArticleDetail } from "@/dentlab/src/pages/article/article-detail.component";
import { SheetContentProps } from "../../sheet-provider/sheetRegistry";
import { SheetContentType, useSheetStore } from "../../sheet.store";

interface ArticleSheetContentProps extends SheetContentProps {
	articleId: number;
}

export const ArticleSheetContent: React.FC<ArticleSheetContentProps> = ({
	sheetKey,
	articleId,
}) => {
	const articles = useCentralStore((state) => state.articles);
	const { openSheet, closeSheet } = useSheetStore((state) => ({
		openSheet: state.openSheet,
		closeSheet: state.closeSheet,
	}));

	const article = useMemo(() => {
		for (const articlesForCode of Object.values(articles)) {
			const found = Object.values(articlesForCode).find(
				(a) => a.id === Number(articleId)
			);
			if (found) return found;
		}
		return null;
	}, [articles, articleId]);

	if (!article) {
		return (
			<div className="p-4 text-sm text-muted-foreground">
				Dieser Artikel existiert nicht.
			</div>
		);
	}

	return (
		<div className="flex h-full flex-col overflow-y-auto">
			<ArticleDetail
				key={article.id}
				article={article}
				onSwitchArticle={(a) => {
					closeSheet(sheetKey);
					openSheet(SheetContentType.ARTICLE, { articleId: a.id });
				}}
			/>
		</div>
	);
};
